import { defineMessages } from 'react-intl';

export const MIN_PASSWORD_LENGTH = 6 as const;

export const POST_CODE_REGEX = /^\d{5}(?:[-\s]\d{4})?$/;
export const YEAR_DATE_REGEX = /^(?:19|20)\d{2}$/;
export const MONTH_DATE_REGEX = /^(0?[1-9]|10|11|12)$/;
export const DAY_DATE_REGEX = /^(0?[1-9]|[12]\d|3[0-1])$/;

export const AuthPageTypes = Object.freeze({
  FORGOT_PASSWORD: 'forgot_password',
  LOGIN: 'login',
  REGISTER: 'register',
  REGISTER_NOT_AVAILABLE: 'register_not_available',
  RESET_PASSWORD: 'reset_password',
} as const);

export const messages = defineMessages({
  forgotPassword: {
    id: 't.forgotPassword',
    defaultMessage: 'Forgot password?',
  },
  resetPassword: {
    id: 't.resetPassword',
    defaultMessage: 'Reset Password',
  },
  login: {
    id: 't.login',
    defaultMessage: 'Log In',
  },
  signUp: {
    id: 't.signUp',
    defaultMessage: 'Sign Up',
  },
  cancel: {
    id: 't.cancel',
    defaultMessage: 'Cancel',
  },
  hasPandoraAccount: {
    id: 't.hasPandoraAccount',
    defaultMessage: 'Already have a Pandora account? {link}',
  },
  noPandoraAccount: {
    id: 't.noPandoraAccount',
    defaultMessage: "Don't have a Pandora account? {link}",
  },
  termsAndPrivacy: {
    id: 't.termsAndPrivacy',
    defaultMessage: "By signing up, you accept and agree to\u000APandora's {terms} and {privacy}.",
  },
  termsOfUse: {
    id: 't.termsOfUse',
    defaultMessage: 'Terms of Use',
  },
  privacyPolicy: {
    id: 't.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
});

export const ModalMessages = defineMessages({
  notNow: {
    id: 't.notNow',
    defaultMessage: 'Not now',
  },
  yes: {
    id: 't.yes',
    defaultMessage: 'Yes',
  },
});

// defaultMessage is lowercase so that we can interleave messages as necessary.  Capitalization is handled by Form.
// id = input name
export const AuthFormMessages = defineMessages({
  username: {
    id: 't.username',
    defaultMessage: 'Email',
  },
  password: {
    id: 't.password',
    defaultMessage: 'Password',
  },
  captcha: {
    id: 't.captcha',
    defaultMessage: 'Slide to verify you’re human',
  },
  captchaPrefix: {
    id: 't.captchaPrefix',
    defaultMessage: 'Check or ',
  },
  captchaProvider: {
    id: 't.captchaProvider',
    defaultMessage: 'Protected by',
  },
});

export const AuthFormErrorMessages = defineMessages({
  required: {
    id: 't.required',
    defaultMessage: 'Required',
  },
  invalidSpecific: {
    id: 't.invalidSpecific',
    defaultMessage: 'Invalid {name}',
  },
  invalid: {
    id: 't.invalid',
    defaultMessage: 'Invalid',
  },
  passwordMustBeLength: {
    id: 't.passwordMustBeLength',
    defaultMessage: `Password must be at least ${MIN_PASSWORD_LENGTH} characters`,
  },
});

export const ServerSideErrorMessages = defineMessages({
  loginFail: {
    id: 't.apiLoginFail',
    defaultMessage: 'Incorrect Email or Password',
  },
  alreadyRegisteredTitle: {
    id: 't.alreadyRegisteredTitle',
    defaultMessage: 'Email has already been registered.',
  },
  alreadyRegisteredContent: {
    id: 't.alreadyRegisteredContent',
    defaultMessage: 'Did you forget your password?',
  },
  apiFail: {
    id: 't.apiFail',
    defaultMessage: 'Something went wrong',
  },
  captchaRequired: {
    id: 't.captchaRequired',
    defaultMessage: "Let's make sure it's you.{br}Complete the CAPTCHA.",
  },
  invalidPasswordResetToken: {
    id: 't.invalidPasswordResetToken',
    defaultMessage: 'Your password link has expired.',
  },
});

export const ViewModes = Object.freeze({
  // View Modes on Login Page
  PWD_SHOW_HIDE: 'password_show_hide',
  ERROR_EMAIL_AND_PWD_EMPTY: 'error_email_and_pwd_empty',
  ERROR_PWD_EMPTY: 'error_pwd_empty',
  ERROR_EMAIL_EMPTY: 'error_email_empty',
  ERROR_WANT_HELP_MODAL: 'error_want_help_modal',
  ERROR_INVALID_CREDENTIALS: 'error_invalid_credentials',
  ERROR_PRESUBMIT_INVALID_EMAIL: 'error_presubmit_invalid_email',
  ERROR_CAPTCHA_REQUIRED: 'error_captcha_required',

  // View Modes on Registration Page
  STANDARD: 'standard',
  ERROR_PRESUBMIT_PWD_LENGTH: 'error_presubmit_pwd_length',
  WHY_ZIP: 'why_zip',
  WHY_GENDER: 'why_gender',
} as const);

export const ActionTypes = Object.freeze({
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGIN_VIEW_UPDATED: 'LOGIN_VIEW_UPDATED',
  LOGOUT: 'LOGOUT',
  LOGOUT_FROM_COMMUNITY: 'LOGOUT_FROM_COMMUNITY',
  REGISTER_VIEW_UPDATED: 'REGISTER_VIEW_UPDATED',
} as const);

export const PageViews = Object.freeze({
  LOGIN: 'login',
  LOGIN_FAILED: 'login_failed',
  REGISTRATION: 'registration',
} as const);
